/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { isMobileOnly } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper/core";
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

import { siteUrl } from "../../utils/constants";
import { StrapiMedia } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";
import ImageLightbox from "../common/ImageLightbox";

// install Swiper modules
SwiperCore.use([Autoplay, EffectFade, Pagination, Navigation]);

const preventScrolling = () => {
  document.documentElement.style.overflow = "hidden";
};

const allowScrolling = () => {
  document.documentElement.style.overflow = "";
};

interface ImagesCarouselTwoProps {
  images?: StrapiMedia[];
  cssClass?: string;
  toTop?: number;
}

const ImagesCarouselTwo = ({
  images,
  cssClass = "mb--40",
  toTop,
}: ImagesCarouselTwoProps) => {
  const [status, setStatus] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [maxHeight, setMaxHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!images || images.length < 2) return;

    let loaded = 0;
    let tallest = 0;

    const urls = images.map((image) => {
      const formats = image.formats;
      if (isMobileOnly && formats?.small) return mediaUrl(formats.small.url);
      return mediaUrl(formats?.large?.url || formats?.small?.url || formats?.thumbnail?.url || "");
    });

    urls.forEach((url) => {
      const img = new window.Image();
      img.onload = () => {
        if (img.naturalHeight > tallest) tallest = img.naturalHeight;
        loaded += 1;
        if (loaded === urls.length) setMaxHeight(tallest);
      };
      img.onerror = () => {
        loaded += 1;
        if (loaded === urls.length) setMaxHeight(tallest);
      };
      img.src = url;
    });
  }, [images]);

  useEffect(() => {
    if ((isOpen || toTop) && status) {
      setStatus(0);
    }
  }, [isOpen, toTop, status]);

  const changeStatusPhotoIndex = (value?: number) => {
    if (value >= 0) {
      setPhotoIndex(value);
      setIsOpen(true);
      preventScrolling();
    }
  };

  const isImagesValid = images && Array.isArray(images);

  const imagesList = isImagesValid
    ? images.map((item) => {
        const isValidItem = Object.keys(item).length !== 0;
        const format =
          isValidItem && item.formats
            ? item.formats.large ||
              item.formats.small ||
              item.formats.small
            : null;
        return isValidItem && format ? mediaUrl(format.url) : "";
      })
    : "";

  const imagesCaptionList =
    images && Array.isArray(images)
      ? images.map((item) => item.caption)
      : "";

  return (
    <div className={`container archive-carousel ${cssClass}`}>
      <div className="row">
        <div className="col-lg-12">
          <div className="inner-wrapper">
            <div className="inner">
              {images && Array.isArray(images) && images !== null ? (
                <Swiper
                  spaceBetween={30}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  className="mySwiper"
                  effect="fade"
                  centeredSlides
                  grabCursor
                  loop
                  style={maxHeight ? { minHeight: maxHeight } : undefined}
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={`home-carousel${index}`}>
                      <button
                        type="button"
                        onClick={() => changeStatusPhotoIndex(index)}
                        onWheel={
                          status
                            ? () => changeStatusPhotoIndex(index)
                            : changeStatusPhotoIndex()
                        }
                        onMouseEnter={
                          status
                            ? () => changeStatusPhotoIndex(index)
                            : changeStatusPhotoIndex()
                        }
                        onKeyDown={() => changeStatusPhotoIndex(index)}
                        tabIndex={0}
                        className="border-0 bg-transparent w-100 d-flex justify-content-center p-0"
                      >
                        {isMobileOnly && image.formats ? (
                          <img
                            src={mediaUrl(image.formats.small.url)}
                            className="mt-4 small-centered-img"
                            alt=""
                          />
                        ) : (
                          <img
                            src={mediaUrl((image.formats?.large?.url ||
                                image.formats?.small?.url ||
                                image.formats?.thumbnail?.url ||
                                "") ??
                              "")}
                            className="mt-4 small-centered-img"
                            alt=""
                          />
                        )}
                      </button>
                    </SwiperSlide>
                  ))}
                  <ImageLightbox
                    open={isOpen}
                    images={Array.isArray(imagesList) ? imagesList : []}
                    captions={Array.isArray(imagesCaptionList) ? imagesCaptionList : []}
                    index={photoIndex}
                    onClose={() => {
                      setIsOpen(false);
                      allowScrolling();
                    }}
                    onIndexChange={setPhotoIndex}
                  />
                </Swiper>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagesCarouselTwo;
